// extracted by mini-css-extract-plugin
module.exports = {"footer-social":"style_footer-social__NMk97","footer-social__item":"style_footer-social__item__1Ki6w","footer-social__link":"style_footer-social__link__zEOyU"};